import {
  addMonthsYYYYMM,
  currentYYYYMM,
  formatYYYYMMLong,
} from './overviewMonthUtils';

export { addMonthsYYYYMM, currentYYYYMM, formatYYYYMMLong };

/**
 * @param {{ dateISO?: string, date?: string } | null | undefined} row
 * @returns {string | null} YYYY-MM
 */
export function swabRowYYYYMM(row) {
  if (!row) return null;
  const iso = row.dateISO != null ? String(row.dateISO).trim() : '';
  if (iso.length >= 7 && /^\d{4}-\d{2}/.test(iso)) return iso.slice(0, 7);
  const d = row.date != null ? String(row.date).trim() : '';
  if (!d) return null;
  const parsed = Date.parse(d.includes('-') ? d : `1 ${d}`);
  if (Number.isNaN(parsed)) return null;
  return currentYYYYMM(new Date(parsed));
}

/**
 * @param {object[]} swabTests
 * @returns {{ min: string, max: string } | null}
 */
export function chartMonthBoundsFromSwabs(swabTests) {
  const yms = (Array.isArray(swabTests) ? swabTests : [])
    .map(swabRowYYYYMM)
    .filter(Boolean)
    .sort();
  if (!yms.length) return null;
  return { min: yms[0], max: yms[yms.length - 1] };
}

/**
 * @param {object[]} swabTests
 * @param {string} yyyyMm
 * @returns {object[]}
 */
export function filterSwabTestsByMonth(swabTests, yyyyMm) {
  const want = (yyyyMm || '').trim();
  if (!want) return Array.isArray(swabTests) ? swabTests : [];
  return (Array.isArray(swabTests) ? swabTests : []).filter((t) => swabRowYYYYMM(t) === want);
}

/**
 * @param {object[]} swabReports
 * @param {string} yyyyMm
 */
export function filterSwabReportsByMonth(swabReports, yyyyMm) {
  const want = (yyyyMm || '').trim();
  if (!want) return Array.isArray(swabReports) ? swabReports : [];
  return (Array.isArray(swabReports) ? swabReports : []).filter((r) => swabRowYYYYMM(r) === want);
}
